import React from 'react';
import style from '../css/footer.module.css';

const Footer = () => {

  return (
    <>
      <div id={style.fot_warp}>
        (주)공감파트너스 고객센터 1600-1634 / itgonggam@naver.com    주 소 : (10391) 경기도 고양시 일산서구 킨텍스로 240 GIFC 오피스동 908-909호 <span className="br_pc" />
        Copyright@2024 CATCH. Registration Administrators All Rights Reserved.
      </div>
    </>

  );
}

export default Footer;
